module.exports = __webpack_public_path__ + "img/pay-ing.7ff1d3b9.gif";